// extracted by mini-css-extract-plugin
export var container = "_ph-0";
export var dotAnimation = "_ph-2";
export var dotsLoading = "_ph-1";